module.exports = __webpack_public_path__ + "img/locked.62c88ff8.svg";